import React from 'react';
import { useTranslation } from 'react-i18next';

import { ShopList } from 'features/shop';
import { TranslationNamespace } from 'i18n';

export const TechOperatorShopsPage: React.FC = () => {
  // TODO: move tkeys to common
  const { t } = useTranslation(TranslationNamespace.TechOperator, {
    keyPrefix: 'pages.shops',
  });
  return <ShopList title={t('title')} />;
};
